import { useEffect, createContext, useState } from 'react'
import { getAuth, getConfig } from '../lib/allauth'
import { Box, Typography, CircularProgress, Fade } from '@mui/material';

export const AuthContext = createContext(null)

export default function Loading() {
  const [showError, setShowError] = useState(false);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setShowError(true);
    }, 6000); // 6 seconds

    return () => clearTimeout(timeout);
  }, []);

  return (
    <Box
      sx={{
        minHeight: '100vh',
        width: '100vw',
        boxSizing: 'border-box',
        background: `url('/gamepictures/backgroundphone.webp') center/cover no-repeat, #0C0717`,
        color: '#ffbfe5',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        padding: 4,
      }}
    >
      {!showError ? (
        <>
          <Typography variant="h5" sx={{ fontWeight: 600, mb: 2 }}>
            Loading...
          </Typography>
          <CircularProgress sx={{ color: '#ffbfe5', mb: 2 }} />
          <Typography variant="body1">
            Bringing the connection a little deeper...
          </Typography>
        </>
      ) : (
        <Fade in={true}>
          <Box>
            <Typography variant="h5" sx={{ fontWeight: 600, mb: 2 }}>
              Hang tight...
            </Typography>
            <Typography variant="body1" sx={{ maxWidth: '400px' }}>
              Our servers are currently unreachable.<br />
              We’re aware of the issue and working to restore access as soon as possible.
            </Typography>
          </Box>
        </Fade>
      )}
    </Box>
  );
}

function LoadingError () {
  return <div>Loading error!</div>
}

export function AuthContextProvider (props) {
  const [auth, setAuth] = useState(undefined)
  const [config, setConfig] = useState(undefined)

  const refreshAuth = async () => {
    try {
      const updatedAuth = await getAuth();
      setAuth(updatedAuth);
    } catch (error) {
      console.error('Failed to refresh authentication:', error);
    }
  };

  useEffect(() => {
    function onAuthChanged (e) {
      setAuth(auth => {
        if (typeof auth === 'undefined') {
          // console.log('Authentication status loaded')
        } else {
          // console.log('Authentication status updated')
        }
        return e.detail
      }
      )
    }

    document.addEventListener('allauth.auth.change', onAuthChanged)
    getAuth().then(data => setAuth(data)).catch((e) => {
      console.error(e)
      setAuth(false)
    })
    getConfig().then(data => setConfig(data)).catch((e) => {
      console.error(e)
    })
    return () => {
      document.removeEventListener('allauth.auth.change', onAuthChanged)
    }
  }, [])
  const loading = (typeof auth === 'undefined') || config?.status !== 200
  return (
    <AuthContext.Provider value={{ auth, setAuth, config, refreshAuth  }}>
      {loading
        ? <Loading />
        : (auth === false
            ? <LoadingError />
            : props.children)}
    </AuthContext.Provider>
  )
}
